document.addEventListener('DOMContentLoaded', () => {
  const brandConceptItems = document.querySelectorAll('.acp-brand-concept_item');

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in');
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  brandConceptItems.forEach(item => {
    observer.observe(item);
  });
});
